import React, {useState, useRef} from 'react';
import {Box, Flex, Center, Button, Image, Divider, Heading, FormLabel, Input, Text} from '@chakra-ui/react';
import GaiLogo from '../../images/logo_300x129_transparent.png';
import FlexCard from '../../components/General/FlexCard';

import {Link, useNavigate, useLocation} from 'react-router-dom';
import {FaSignInAlt} from 'react-icons/fa';
import {User} from '../../service/Urls';
import {postNoAuth} from '../../service/ApiService';
import jwtDecode from 'jwt-decode';
import {setUserRole, setUserToken} from '../../helpers/localStorage';
import ErrorHelper from '../../service/ErrorHelper';
import LoadingWheel from '../../components/General/LoadingWheel';
import {useEffect} from 'react';
import Roles from '../../constants/Roles';

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // rather than using a form we use refs/state since browser autofill wasn't being recognized here
  const userRef = useRef(null);
  const passRef = useRef(null);

  const [userErrors, setUserErrors] = useState(false);
  const [passErrors, setPassErrors] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // If user tried to go to specific url but wasn't logged in, this variable stores where they'll go
  const from = location.state?.from?.pathname || '/home';

  // this makes the popup showup, must pass toastResponse to the ErrorHelper component
  const [toastResponse, setToastResponse] = useState(undefined);

  const onSubmit = async () => {
    const username = userRef?.current.value;
    const password = passRef?.current.value;

    if (username && password) {
      setIsLoading(true);
      setUserErrors(false);
      setPassErrors(false);

      const data = {userName: username, password: password};
      const userRequest = await postNoAuth(User.SIGN_IN, data);

      setToastResponse(userRequest);
      if (!userRequest.error) {
        const userInfo = jwtDecode(userRequest.token);
        setUserToken(userRequest.token);
        setUserRole(userInfo.role);
        setIsLoading(false);

        navigate(getDefaultPage(userInfo.role), {replace: true});
        return;
      }
    } else {
      if (!username) {
        setUserErrors(true);
      } else {
        setUserErrors(false);
      }
      if (!password) {
        setPassErrors(true);
      } else {
        setPassErrors(false);
      }
    }
    setIsLoading(false);
    return;
  };

  // normally if multiple roles are selected for a client 'role' is an array, if only one is selected it is a single string value.
  const getDefaultPage = role => {
    switch (role) {
      case Roles.CLIENT_PERSONNEL:
        return '/reports/client';
      default:
        return from;
    }
  };

  useEffect(() => {}, []);
  return (
    <form onSubmit={onSubmit}>
      <Center mt="12">
        <FlexCard>
          <Flex justifyContent={'center'} mx="12">
            <Box>
              <Image mx={'30'} my="3" src={GaiLogo} maxW={{base: 'md', md: 'sm'}} />
              <Flex justifyContent={'center'}>
                <Heading>Login</Heading>
              </Flex>
              <Divider my="5" />

              {!isLoading && (
                <>
                  <Box mx="1">
                    <FormLabel htmlFor={'userName'} mb="-0.5" ml="1" fontSize="sm">
                      {'Username'}
                    </FormLabel>
                    <Input
                      placeholder={'Username'}
                      id="userName"
                      ref={userRef}
                      onKeyPress={e => {
                        if (e.key === 'Enter') {
                          onSubmit();
                        }
                      }}
                    />

                    {userErrors && (
                      <Text color="red.400" fontSize="sm">
                        *Username is required
                      </Text>
                    )}
                  </Box>

                  <Box mx="1">
                    <FormLabel htmlFor={'password'} mb="-0.5" ml="1" fontSize="sm">
                      {'Password'}
                    </FormLabel>
                    <Input
                      placeholder={'Password'}
                      id="password"
                      ref={passRef}
                      type="password"
                      onKeyPress={e => {
                        if (e.key === 'Enter') {
                          onSubmit();
                        }
                      }}
                    />
                    {/* errors will return when field validation fails  */}
                    {passErrors && (
                      <Text color="red.400" fontSize="sm">
                        *Password is required
                      </Text>
                    )}
                  </Box>
                </>
              )}
              {isLoading && (
                <Flex justifyContent={'center'}>
                  <LoadingWheel />
                </Flex>
              )}

              <Button type="button" w="100%" colorScheme="teal" leftIcon={<FaSignInAlt />} my="5" onClick={onSubmit}>
                Sign in
              </Button>
              <Flex justifyContent={'center'} mb="5">
                <Link to="/forgot-password">Forgot Password?</Link>
              </Flex>
            </Box>
          </Flex>
        </FlexCard>
      </Center>
      <ErrorHelper toastResponse={toastResponse} />
    </form>
  );
};
export default Login;
// @param {id, name, register, errors, required=false}
